// ===== Enums =====

import {
    AUTHENTICATION_TYPE,
    FIREBASE_AUTH_SIGN_IN_PROVIDER_ID_TYPE,
}                                           from '../enums';

export const EMAIL_PASSWORD_SIGN_IN_LABEL = 'email/password';

export const getAuthenticationTypeLabel = (type: AUTHENTICATION_TYPE): string => {
    switch (type) {
    case AUTHENTICATION_TYPE.google:
        return 'Google';
    case AUTHENTICATION_TYPE.github:
        return 'GitHub';
    case AUTHENTICATION_TYPE.facebook:
        return 'Facebook';
    case AUTHENTICATION_TYPE.xTwitter:
        return 'X/Twitter';
    case AUTHENTICATION_TYPE.email:
        return EMAIL_PASSWORD_SIGN_IN_LABEL;
    case AUTHENTICATION_TYPE.anonymous:
        return 'guest';
    default:
        return 'this provider';
    }
};

export const mapSignInMethodToAuthenticationType = (
    method: string,
): AUTHENTICATION_TYPE | undefined => {
    switch (method) {
    case FIREBASE_AUTH_SIGN_IN_PROVIDER_ID_TYPE.google:
        return AUTHENTICATION_TYPE.google;
    case FIREBASE_AUTH_SIGN_IN_PROVIDER_ID_TYPE.github:
        return AUTHENTICATION_TYPE.github;
    case FIREBASE_AUTH_SIGN_IN_PROVIDER_ID_TYPE.facebook:
        return AUTHENTICATION_TYPE.facebook;
    case FIREBASE_AUTH_SIGN_IN_PROVIDER_ID_TYPE.xTwitter:
        return AUTHENTICATION_TYPE.xTwitter;
    case FIREBASE_AUTH_SIGN_IN_PROVIDER_ID_TYPE.email:
        return AUTHENTICATION_TYPE.email;
    case FIREBASE_AUTH_SIGN_IN_PROVIDER_ID_TYPE.anonymous:
        return AUTHENTICATION_TYPE.anonymous;
    default:
        return undefined;
    }
};

export const getSignInMethodLabel = (method: string): string => {
    const authenticationType = mapSignInMethodToAuthenticationType(method);
    if (!authenticationType) return method;
    return getAuthenticationTypeLabel(authenticationType);
};
